import React from "react";

import ModalBasic from "../ModalBasic";

export default function ModalInformation({
   showModal,
   setShowModal,
   title,
   detail,
   type,
}) {
   if (type === "error") {
      type = (
         <div className="w-20 h-20 rounded-full flex items-center justify-center shrink-0 bg-rose-100">
            <svg
               className="w-10 h-10 shrink-0 fill-current text-rose-500"
               viewBox="0 0 16 16"
            >
               <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
            </svg>
         </div>
      );
   } else if (type === "success") {
      type = (
         <div className="w-20 h-20 rounded-full flex items-center justify-center shrink-0 bg-emerald-100 dark:bg-emerald-400/30">
            <svg
               className="w-10 h-10 shrink-0 fill-current text-emerald-500"
               viewBox="0 0 16 16"
            >
               <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z" />
            </svg>
         </div>
      );
   }
   return (
      <ModalBasic
         id="loading-modal"
         modalOpen={showModal}
         setModalOpen={setShowModal}
      >
         <div className="pb-4 px-4 flex space-y-4">
            {/* Content */}
            <div className="w-full flex flex-col items-center space-y-2">
               {/* Icon */}
               {type}
               {/* Modal header */}
               <div className="py-2">
                  <div className="text-lg font-semibold text-slate-800">
                     {title}
                  </div>
               </div>
               {/* Modal content */}
               <div className="text-sm mb-10">
                  <div className="text-justify overflow-auto max-h-25">
                     <p>{detail}</p>
                  </div>
               </div>
               {/* Modal footer */}
               <div className="py-2 flex flex-wrap justify-end space-x-2">
                  <button
                     className="btn-sm border-slate-200 hover:border-slate-300 text-slate-600"
                     onClick={(e) => {
                        e.stopPropagation();
                        setShowModal(false);
                     }}
                  >
                     Kembali
                  </button>
               </div>
            </div>
         </div>
      </ModalBasic>
   );
}
